import AddIcon from 'components/ReusableComponents/Icons/Add'

import styles from './OptInButton.module.scss'

const OptInButton = ({ onClick }) => (
  <button onClick={onClick} className={styles.button}>
    <AddIcon />
    <div className={styles.buttonTexts}>
      <div className={styles.buttonTitle}>Opt-in</div>
      <div className={styles.buttonDescription}>Request consent</div>
    </div>
  </button>
)

export default OptInButton
